import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import SEO from "../components/SEO";
import { CONTACT } from "../data/mock";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Privacy Policy – A.C.D.T.";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <SEO />
      <Navbar />
      <LegalLayout title="Privacy Policy" lastUpdate="01 Giugno 2026">
        <Section title="1. Titolare del Trattamento">
          <p>
            Il Titolare del trattamento dei dati personali è <strong>{CONTACT.org}</strong>,
            con sede in {CONTACT.address}.
          </p>
          <ul>
            <li>Codice Fiscale: {CONTACT.cf}</li>
            <li>Partita IVA: {CONTACT.piva}</li>
            <li>Email: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            <li>Telefono: {CONTACT.phone}</li>
          </ul>
        </Section>

        <Section title="2. Tipologie di dati raccolti">
          <p>Raccogliamo le seguenti categorie di dati personali:</p>
          <ul>
            <li><strong>Dati anagrafici e di contatto</strong>: nome, cognome, indirizzo email, numero di telefono, codice fiscale o partita IVA.</li>
            <li><strong>Dati di pagamento</strong>: gestiti direttamente dai provider esterni (PayPal, Google Pay, Apple Pay, Klarna) o dalla banca per i bonifici. ACDT non conserva i dati di carta di credito.</li>
            <li><strong>Dati di navigazione</strong>: indirizzo IP, tipo di browser, sistema operativo, pagine visitate, in forma anonima e aggregata.</li>
            <li><strong>Cookie</strong>: si veda la <a href="/cookie-policy">Cookie Policy</a>.</li>
          </ul>
        </Section>

        <Section title="3. Finalità del trattamento">
          <p>I dati sono trattati per le seguenti finalità:</p>
          <ol>
            <li>Gestione dell'iscrizione all'Associazione e al Registro;</li>
            <li>Erogazione del corso e dei servizi formativi acquistati;</li>
            <li>Gestione dei pagamenti e degli adempimenti fiscali/amministrativi;</li>
            <li>Comunicazioni istituzionali, eventi, masterclass e attività dell'Associazione;</li>
            <li>Adempimento degli obblighi di legge.</li>
          </ol>
        </Section>

        <Section title="4. Base giuridica">
          <p>
            Il trattamento si basa sul <strong>consenso</strong> dell'interessato (art. 6, lett. a GDPR),
            sull'<strong>esecuzione di un contratto</strong> (art. 6, lett. b GDPR) e sull'
            <strong>adempimento di obblighi di legge</strong> (art. 6, lett. c GDPR).
          </p>
        </Section>

        <Section title="5. Modalità del trattamento e conservazione">
          <p>
            I dati sono trattati con strumenti informatici e cartacei, adottando misure tecniche e
            organizzative idonee a garantirne la sicurezza, riservatezza e integrità.
            I dati sono conservati per il tempo necessario al perseguimento delle finalità indicate
            e in ogni caso nei limiti previsti dalla normativa fiscale e civilistica.
          </p>
        </Section>

        <Section title="6. Comunicazione e destinatari dei dati">
          <p>I dati possono essere comunicati a:</p>
          <ul>
            <li>Enti partner (Centro Studi E.S.S.E., Pigreco Formazione) per l'erogazione dei servizi;</li>
            <li>Provider di pagamento (PayPal, Google Pay, Apple Pay, Klarna);</li>
            <li>Autorità pubbliche, qualora previsto dalla legge;</li>
            <li>Consulenti esterni (commercialista, legale) per gli adempimenti amministrativi.</li>
          </ul>
          <p>I dati non sono diffusi e non vengono trasferiti in Paesi extra-UE senza adeguate garanzie.</p>
        </Section>

        <Section title="7. Diritti dell'interessato">
          <p>Ai sensi degli artt. 15-22 GDPR, hai diritto a:</p>
          <ul>
            <li>Accedere ai tuoi dati;</li>
            <li>Rettificarli o cancellarli;</li>
            <li>Limitare od opporti al trattamento;</li>
            <li>Ottenere la portabilità dei dati;</li>
            <li>Revocare il consenso in qualsiasi momento;</li>
            <li>Proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).</li>
          </ul>
          <p>
            Per esercitare i tuoi diritti scrivi a <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.
          </p>
        </Section>

        <Section title="8. Modifiche">
          <p>
            La presente Privacy Policy può essere aggiornata. Ogni modifica sarà pubblicata su questa pagina
            con l'indicazione della data di ultimo aggiornamento.
          </p>
        </Section>
      </LegalLayout>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl md:text-2xl font-extrabold text-[#0a1f55] mb-3">{title}</h2>
      <div className="text-[15px] text-slate-700 leading-relaxed space-y-3 [&_a]:text-[#102a6b] [&_a]:underline [&_a]:font-semibold [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:space-y-1.5 [&_ol]:space-y-1.5">
        {children}
      </div>
    </section>
  );
}
